import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import InlineTable, { InlineColDef } from '../util/InlineTable';

interface Loc { id: number; name: string; active: boolean | null; }

const columns: InlineColDef<Loc>[] = [
  { key: 'name', label: t('Name') || 'Name', type: 'text', placeholder: t('Name') || 'Location…' },
];

const Locations: React.FC = () => {
  const [rows, setRows] = useState<Loc[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await axios.get('location'); setRows(Array.isArray(data) ? data : []); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async (row: Partial<Loc>) => {
    if (!row.name?.trim()) return;
    await axios.post('location/add', { name: row.name.trim() });
    await load();
  };

  const handleEdit = async (id: string | number, row: Partial<Loc>) => {
    await axios.put(`location/${id}`, { name: row.name });
    await load();
  };

  const handleDelete = async (id: string | number) => {
    if (!window.confirm(t('AreYouSure') || 'Are you sure?')) return;
    await axios.delete(`location/${id}`);
    await load();
  };

  return (
    <div className="bg-[var(--bg-form)] rounded-[5px]" style={{ border: 'var(--border-input)', overflow: 'hidden' }}>
      <InlineTable<Loc>
        columns={columns}
        rows={rows}
        getKey={r => r.id}
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addLabel={`+ ${t('Location') || 'Location'}`}
        emptyText={t('Empty') || 'No locations'}
      />
    </div>
  );
};

export default Locations;
